/* eslint-disable no-restricted-imports */
import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import { useSelector } from "react-redux";
import objectPath from "object-path";
import { useHtmlClassService } from "../../../_core/MetronicLayout";
import { DropdownTopbarItemToggler } from "../../../../_partials/dropdowns";
import { isFullAdmin } from "../../../../../app/modules/Auth/access";

const getInitial = (user) => {
  const name = user?.first_name || user?.firstname || user?.email || "A";
  return name.charAt(0).toUpperCase();
};

const getFullName = (user) => {
  return [user?.first_name || user?.firstname, user?.last_name || user?.lastname]
    .filter(Boolean)
    .join(" ") || "Administrador";
};

export function UserProfileDropdown() {
  const { user } = useSelector((state) => state.auth);
  const uiService = useHtmlClassService();
  const layoutProps = useMemo(() => {
    return {
      light:
        objectPath.get(uiService.config, "extras.user.dropdown.style") ===
        "light",
    };
  }, [uiService]);

  const fullName = getFullName(user);
  const initial = getInitial(user);
  const profileLabel = isFullAdmin(user) ? "Perfil de administrador" : "Perfil de Marketing";

  return (
    <Dropdown drop="down" alignRight>
      <Dropdown.Toggle
        as={DropdownTopbarItemToggler}
        id="dropdown-toggle-user-profile"
      >
        <div className="btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2">
          <span className="text-muted font-weight-bold font-size-base d-none d-md-inline mr-1">
            Hola,
          </span>
          <span className="text-dark-50 font-weight-bolder font-size-base d-none d-md-inline mr-3">
            {user?.first_name || user?.firstname || "Admin"}
          </span>
          <span className="symbol symbol-35 symbol-light-success">
            <span className="symbol-label font-size-h5 font-weight-bold">
              {initial}
            </span>
          </span>
        </div>
      </Dropdown.Toggle>

      <Dropdown.Menu className="p-0 m-0 dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-md admin-user-menu">
        <div className={`admin-user-menu__header ${layoutProps.light ? "admin-user-menu__header--light" : ""}`}>
          <span className="symbol symbol-45 symbol-light-primary mr-4">
            <span className="symbol-label font-size-h4 font-weight-bold">
              {initial}
            </span>
          </span>
          <div className="min-w-0">
            <div className="font-weight-bolder text-dark text-truncate">
              {fullName}
            </div>
            <div className="text-muted font-size-sm text-truncate">
              {user?.email || "Sin email"}
            </div>
          </div>
        </div>

        <div className="navi navi-spacer-x-0 py-3">
          <div className="navi-item px-8">
            <div className="navi-link admin-user-menu__readonly">
              <div className="navi-icon mr-2">
                <i className="flaticon2-user text-primary" />
              </div>
              <div className="navi-text">
                <div className="font-weight-bold">{profileLabel}</div>
                <div className="text-muted">Sesión activa del panel</div>
              </div>
            </div>
          </div>

          <div className="navi-separator my-3" />

          <div className="navi-footer px-8 py-4 d-flex justify-content-end">
            <Link to="/logout" className="btn btn-light-primary font-weight-bold">
              Cerrar sesión
            </Link>
          </div>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
}
